import React from "react";
import Header from '../_part/Header';
import Poster from '../_part/Poster';

import '../_css/post.css'

function Post(){

    return(
        <div>
            
            <div className="body">

                <div className="gridbody">
                    {Poster("python", "./_img/python.jpg", "/Post/python")}
                    {Poster(2, "", "/")}
                    {Poster(3, "", "/")}
                    {Poster(4, "", "/")}
                    {Poster(1, "", "/")}
                    {Poster(2, "", "/")}
                    {Poster(3, "", "/")}
                    {Poster(4, "", "/")}
                    {Poster(1, "", "/")}
                    {Poster(2, "", "/")}
                    {Poster(3, "", "/")}
                    {Poster(4, "", "/")}
                </div>


              
                <div style={{paddingTop:"100%"}}></div>

                
            </div>




            <Header />
        </div>
    );
}

export default Post;
